// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
// import {
//   Box,
//   Button,
//   CircularProgress,
//   ListItem,
//   TextField,
//   Typography,
// } from "@mui/material";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import React, { useEffect, useState } from "react";
// import { FiArrowDownLeft, FiArrowUpRight } from "react-icons/fi";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchJobItems } from "../actions/jobAction";
// import HeaderBannerPage from "../components/HeaderBannerPage";

// const JobsHistory = () => {
//   const dispatch = useDispatch();
//   const { jobItems, loading } = useSelector((state) => state.job);
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [openDatePicker, setOpenDatePicker] = useState(false);

//   const employeeId = localStorage.getItem("employeeId");
//   const role = localStorage.getItem("role");

//   useEffect(() => {
//     if (employeeId && role) {
//       const formattedDate = selectedDate.toISOString().split("T")[0];
//       dispatch(fetchJobItems(formattedDate, employeeId, role));
//     }
//   }, [dispatch, selectedDate, employeeId, role]);

//   const handleDateChange = (date) => {
//     setSelectedDate(date);
//     const formattedDate = date.toISOString().split("T")[0];
//     dispatch(fetchJobItems(formattedDate, employeeId, role));
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDateFns}>
//       <Box sx={{ padding: "16px", maxWidth: "700px", margin: "0 auto",left:0,top:0 }}>
//         <HeaderBannerPage />
//         <Box sx={{ textAlign: "center", mt: 2 }}>
//           <Button
//             variant="contained"
//             onClick={() => setOpenDatePicker(true)}
//             sx={{
//               borderRadius: "25px",
//               padding: "10px 20px",
//               backgroundColor: "#142c54",
//               color: "#fff",
//               fontWeight: "bold",
//               textTransform: "none",
//               "&:hover": {
//                 backgroundColor: "#0D47A1",
//               },
//             }}
//           >
//             <CalendarTodayIcon sx={{ marginRight: "8px" }} />
//             Select the Date
//           </Button>
//         </Box>

//         {openDatePicker && (
//           <DatePicker
//             open={openDatePicker}
//             value={selectedDate}
//             onChange={handleDateChange}
//             onClose={() => setOpenDatePicker(false)}
//             renderInput={(params) => <TextField {...params} sx={{ display: "none" }} />}
//           />
//         )}

//         <Box sx={{ marginTop: "20px", maxHeight: "500px", overflowY: "auto" }}>
//           {loading ? (
//             <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
//               <CircularProgress />
//             </Box>
//           ) : jobItems && jobItems.length > 0 ? (
//             jobItems.map((group) => (
//               <Box key={group.JobId} sx={{ marginBottom: "16px" }}>
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     backgroundColor: "#F5F5F5",
//                     padding: "8px",
//                     borderRadius: "8px",
//                     border: "1px solid #ddd",
//                     fontWeight: "bold",
//                     textAlign: "center",
//                     color: "#424242",
//                   }}
//                 >
//                   {group.JobDecription}
//                 </Typography>
//                 {group.AttendancList.map((item) => (
//                   <ListItem
//                     key={item.id}
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                       padding: "16px",
//                       borderRadius: "10px",
//                       backgroundColor: "#fff",
//                       boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
//                       marginBottom: "12px",
//                       transition: "transform 0.2s",
//                       "&:hover": {
//                         transform: "scale(1.02)",
//                         boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.15)",
//                       },
//                     }}
//                   >
//                     <Box sx={{ flex: 1 }}>
//                       <Typography variant="body1" sx={{ fontWeight: "bold", color: "#142c54" }}>
//                         {item.serviceNo || "No Service No Available"}
//                       </Typography>
//                       <Typography
//                         variant="body2"
//                         sx={{ marginTop: "4px", color: "#000", fontWeight: "500" }}
//                       >
//                         {item.EmpName || "No Employee Name Available"}
//                       </Typography>
//                     </Box>
//                     <Box display="flex" alignItems="center">
//                       <Typography
//                         sx={{
//                           marginRight: 3,
//                           color: "#43A047",
//                           fontWeight: "bold",
//                           display: "flex",
//                           alignItems: "center",
//                         }}
//                       >
//                         {item.inTime || "No Time"}
//                         <FiArrowDownLeft style={{ marginLeft: "4px" }} />
//                       </Typography>
//                       <Typography
//                         sx={{
//                           color: "#E53935",
//                           fontWeight: "bold",
//                           display: "flex",
//                           alignItems: "center",
//                         }}
//                       >
//                         {item.outTime || "No Time"}
//                         <FiArrowUpRight style={{ marginLeft: "4px" }} />
//                       </Typography>
//                     </Box>
//                   </ListItem>
//                 ))}
//               </Box>
//             ))
//           ) : (
//             <Box sx={{ textAlign: "center", marginTop: "40px" }}>
//               <SentimentDissatisfiedIcon sx={{ fontSize: "48px", color: "#9E9E9E" }} />
//               <Typography variant="body1" sx={{ marginTop: "8px", color: "#757575" }}>
//                 No job history data available.
//               </Typography>
//             </Box>
//           )}
//         </Box>
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default JobsHistory;




import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import {
  Box,
  Button,
  CircularProgress,
  ListItem,
  TextField,
  Typography,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import React, { useEffect, useState } from "react";
import { FiArrowDownLeft, FiArrowUpRight } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobItems } from "../actions/jobAction";
import HeaderBannerPage from "../components/HeaderBannerPage";
import axios from "axios";
const JobsHistory = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.job);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [jobsList, setJobsList] = useState([]);
  const [selectedJob, setSelectedJob] = useState("unassigned");
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [loadingJobs, setLoadingJobs] = useState(false);
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const [hasUnassigned, setHasUnassigned] = useState(false);
  
 
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isExtraSmall = useMediaQuery('(max-width:360px)');
  const employeeId = localStorage.getItem("employeeId");
  const role = localStorage.getItem("role");
  const location = localStorage.getItem("role") || "HUC";
  const company = localStorage.getItem("department") || "DTS";
  
  const fetchJobs = async (date) => {
    setLoadingJobs(true);
    try {
      const formattedDate = date.toISOString().split("T")[0];
      const response = await axios.get(
        `https://esystems.cdl.lk/backend/AttendMe2/attme/GetJobs?date=${formattedDate}&serviceNo=${employeeId}`,
        {
          method: "GET",
          headers: {
            UserId: "DTSUSER",
            Password: "Dts@10099",
          },
        }
      );
      
      if (response.data && response.data.responceType && response.data.JobsList) {
        
        const hasUnassignedJobs = response.data.JobsList.some(job => !job.iwNo || job.iwNo === "0");
        setHasUnassigned(hasUnassignedJobs);
        
        setJobsList(response.data.JobsList);
      } else {
        setJobsList([]);
        setHasUnassigned(false);
      }
    } catch (error) {
      console.error("Error fetching jobs:", error);
      setJobsList([]);
      setHasUnassigned(false);
    } finally {
      setLoadingJobs(false);
    }
  };
  
  const fetchEmployeeDetails = async (date, iwNo) => {
    setLoadingEmployees(true);
    try {
      const formattedDate = date.toISOString().split("T")[0];
      const requestIwNo = iwNo === "unassigned" ? "0" : iwNo;
      
      const response = await axios.get(
        `https://esystems.cdl.lk/backend/AttendMe2/attme/GetEmpJobDetails?date=${formattedDate}&iwNo=${requestIwNo}&location=${location}&company=${company}`,
        {
          method: "GET",
          headers: {
            UserId: "DTSUSER",
            Password: "Dts@10099",
          },
        }
      );
      
      if (response.data && response.data.responceType && response.data.AttendancList) {
        setEmployeeDetails(response.data.AttendancList);
      } else {
        setEmployeeDetails([]);
      }
    } catch (error) {
      console.error("Error fetching employee details:", error);
      setEmployeeDetails([]);
    } finally {
      setLoadingEmployees(false);
    }
  };
  // Fetch unassigned employees
  const fetchUnassignedEmployees = async (date) => {
    setLoadingEmployees(true);
    try {
      const formattedDate = date.toISOString().split("T")[0];
      
      const response = await axios.get(
        `https://esystems.cdl.lk/backend/AttendMe2/attme/GetEmpJobDetails?date=${formattedDate}&iwNo=0&location=${location}&company=${company}`,
        {
          method: "GET",
          headers: {
            UserId: "DTSUSER",
            Password: "Dts@10099",
          },
        }
      );
      
      if (response.data && response.data.responceType && response.data.AttendancList) {
        setEmployeeDetails(response.data.AttendancList);
      } else {
        setEmployeeDetails([]);
      }
    } catch (error) {
      console.error("Error fetching unassigned employees:", error);
      setEmployeeDetails([]);
    } finally {
      setLoadingEmployees(false);
    }
  };
  useEffect(() => {
    if (employeeId && role) {
      fetchJobs(selectedDate);
    }
  }, [selectedDate, employeeId, role]);
  
  useEffect(() => {
    if (employeeId && role && selectedDate) {
      fetchUnassignedEmployees(selectedDate);
    }
  }, []);
  const handleDateChange = (date) => {
    setSelectedDate(date);
    fetchJobs(date);
    
    
    if (selectedJob && selectedJob !== "unassigned") {
      fetchEmployeeDetails(date, selectedJob);
    } else if (selectedJob === "unassigned") {
      fetchUnassignedEmployees(date);
    }
  };
  
  const handleJobChange = (event) => {
    const jobId = event.target.value;
    setSelectedJob(jobId);
    
    if (jobId === "unassigned") {
      fetchUnassignedEmployees(selectedDate);
    } else if (jobId) {
      const selectedJobItem = jobsList.find(job => job.iwNo === jobId);
      if (selectedJobItem) {
        fetchEmployeeDetails(selectedDate, selectedJobItem.iwNo);
      }
    } else {
      setEmployeeDetails([]);
    }
  };
  const getJobTitle = () => {
    if (selectedJob === "unassigned") {
      return "UnAssign Employees";
    }
    return jobsList.find(job => job.iwNo === selectedJob)?.jobDescription || "Selected Job";
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ 
        padding: { xs: "8px", sm: "16px" }, 
        maxWidth: "700px", 
        margin: "0 auto", 
        left: 0, 
        top: 0,
        width: "100%" 
      }}>
        <HeaderBannerPage />
        <Box sx={{ textAlign: "center", mt: 2 }}>
          <Button
            variant="contained"
            onClick={() => setOpenDatePicker(true)}
            sx={{
              borderRadius: "25px",
              padding: { xs: "8px 16px", sm: "10px 20px" },
              backgroundColor: "#142c54",
              color: "#fff",
              fontWeight: "bold",
              textTransform: "none",
              fontSize: { xs: "13px", sm: "16px" },
              "&:hover": {
                backgroundColor: "#0D47A1",
              },
              mb: 2,
            }}
          >
            <CalendarTodayIcon sx={{ marginRight: "8px", fontSize: { xs: "18px", sm: "24px" } }} />
            Select the Date
          </Button>
        </Box>
        {openDatePicker && (
          <DatePicker
            open={openDatePicker}
            value={selectedDate}
            onChange={handleDateChange}
            onClose={() => setOpenDatePicker(false)}
            renderInput={(params) => <TextField {...params} sx={{ display: "none" }} />}
          />
        )}
        {/* Job Selection Dropdown */}
        <FormControl fullWidth sx={{ mt: 2, mb: 3 }}>
          <InputLabel id="job-select-label" sx={{ fontSize: { xs: "14px", sm: "16px" } }}>Select Job</InputLabel>
          <Select
            labelId="job-select-label"
            id="job-select"
            value={selectedJob}
            label="Select Job"
            onChange={handleJobChange}
            disabled={loadingJobs || (jobsList.length === 0 && !hasUnassigned)}
            sx={{
              fontSize: { xs: "14px", sm: "16px" },
              '& .MuiSelect-select': {
                padding: { xs: '8px 14px', sm: '14px 14px' }
              }
            }}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: isMobile ? 250 : 300,
                  width: 'auto',
                },
              },
            }}
          >
            {/* <MenuItem value="" sx={{ fontSize: { xs: "14px", sm: "16px" } }}>
              <em>Select a job</em>
            </MenuItem> */}
            <MenuItem
              value="unassigned"
              sx={{
                
                
                borderBottom: "1px dashed #e0e0e0",
                whiteSpace: "normal",
                fontSize: { xs: "14px", sm: "16px" }
              }}
            >
              Unassign Employees
            </MenuItem>
            {jobsList
              .filter((job) => job.iwNo && job.iwNo !== "0")
              .map((job) => (
                <MenuItem
                  key={job.iwNo}
                  value={job.iwNo}
                  sx={{
                    whiteSpace: "normal",
                    padding: { xs: "10px 16px", sm: "12px 16px" },
                    fontSize: { xs: "14px", sm: "16px" }
                  }}
                >
                  {job.jobDescription}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <Box sx={{ 
          marginTop: "20px", 
          maxHeight: { xs: "calc(100vh - 250px)", sm: "500px" }, 
          overflowY: "auto", 
          padding: { xs: "0 4px", sm: 0 } 
        }}>
          {loadingJobs ? (
            <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
              <CircularProgress size={isMobile ? 30 : 40} />
            </Box>
          ) : jobsList.length === 0 && !hasUnassigned ? (
            <Box sx={{ textAlign: "center", marginTop: "40px" }}>
              {/* <SentimentDissatisfiedIcon sx={{ fontSize: { xs: "36px", sm: "48px" }, color: "#9E9E9E" }} /> */}
              <Typography variant="body1" sx={{ marginTop: "8px", color: "#757575", fontSize: { xs: "14px", sm: "16px" } }}>
                No jobs available for the selected date.
              </Typography>
            </Box>
          ) : selectedJob ? (
            loadingEmployees ? (
              <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                <CircularProgress size={isMobile ? 30 : 40} />
              </Box>
            ) : employeeDetails.length > 0 ? (
              <Box sx={{ marginBottom: "16px" }}>
                <Typography
                  variant="h6"
                  sx={{
                    backgroundColor: "#F5F5F5",
                    padding: { xs: "6px", sm: "8px" },
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                    fontWeight: "bold",
                    textAlign: "center",
                    color: "#424242",
                    mb: 2,
                    fontSize: { xs: "15px", sm: "18px" },
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical"
                  }}
                >
                  {getJobTitle()}
                </Typography>
                {employeeDetails.map((item, index) => (
                  <ListItem
                    key={index}
                    sx={{
                      display: "flex",
                      flexDirection: isExtraSmall ? "column" : "row",
                      justifyContent: "space-between",
                      alignItems: isExtraSmall ? "flex-start" : "center",
                      padding: { xs: "12px", sm: "16px" },
                      borderRadius: "10px",
                      backgroundColor: "#fff",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
                      marginBottom: "12px",
                      transition: "transform 0.2s",
                      "&:hover": {
                        transform: isMobile ? "none" : "scale(1.02)",
                        boxShadow: isMobile ? "0px 4px 8px rgba(0, 0, 0, 0.3)" : "0px 6px 12px rgba(0, 0, 0, 0.15)",
                      },
                    }}
                  >
                    <Box sx={{ 
                      flex: 1,
                      marginBottom: isExtraSmall ? 2 : 0,
                      width: isExtraSmall ? "100%" : "auto"
                    }}>
                      <Typography variant="body1" sx={{ 
                        fontWeight: "bold", 
                        color: "#142c54",
                        fontSize: { xs: "14px", sm: "16px" } 
                      }}>
                        {item.serviceNo || "No Service No Available"}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ 
                          marginTop: "4px", 
                          color: "#000", 
                          fontWeight: "500",
                          fontSize: { xs: "13px", sm: "14px" } 
                        }}
                      >
                        {item.EmpName || "No Employee Name Available"}
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" sx={{ width: isExtraSmall ? "100%" : "auto" }}>
                      <Typography
                        sx={{
                          marginRight: { xs: 2, sm: 3 },
                          color: "#43A047",
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          fontSize: { xs: "13px", sm: "14px" }
                        }}
                      >
                        {item.inTime || "No Time"}
                        <FiArrowDownLeft style={{ marginLeft: "4px" }} />
                      </Typography>
                      <Typography
                        sx={{
                          color: "#E53935",
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          fontSize: { xs: "13px", sm: "14px" }
                        }}
                      >
                        {item.outTime || "No Time"}
                        <FiArrowUpRight style={{ marginLeft: "4px" }} />
                      </Typography>
                    </Box>
                  </ListItem>
                ))}
              </Box>
            ) : (
              <Box sx={{ textAlign: "center", marginTop: "40px" }}>
                {/* <SentimentDissatisfiedIcon sx={{ fontSize: { xs: "36px", sm: "48px" }, color: "#9E9E9E" }} /> */}
                <Typography variant="body1" sx={{ marginTop: "8px", color: "#757575", fontSize: { xs: "14px", sm: "16px" } }}>
                  No employee details available for the selected job.
                </Typography>
              </Box>
            )
          ) : (
            <Box sx={{ textAlign: "center", marginTop: "40px" }}>
              <Typography variant="body1" sx={{ color: "#757575", fontSize: { xs: "14px", sm: "16px" } }}>
                Please select a job to view employee details.
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </LocalizationProvider>
  );
};
export default JobsHistory;